<template>
  <vx-card no-shadow>

    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
<!--      <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4" />-->
<!--      <div>-->
<!--        <vs-button class="mr-4 sm:mb-0 mb-2" disabled>Upload photo</vs-button>-->
<!--        <vs-button type="border" color="danger" disabled>Remove</vs-button>-->
<!--        <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p>-->
<!--      </div>-->
    </div>
    <div class="mt-4 mb-12">
      <h5 class="mb-2">Theme Mode</h5>
      <div>
        <vs-radio v-model="themeMode" vs-value="light" class="mr-4" vs-name="theme-mode-light">Light</vs-radio>
        <vs-radio v-model="themeMode" vs-value="dark" class="mr-4" vs-name="theme-mode-dark">Dark</vs-radio>
      </div>
    </div>

    <!-- Info -->
    <vs-input readonly class="w-full mb-base" label-placeholder="First Name" v-model="current_user.first_name"></vs-input>
    <vs-input readonly class="w-full mb-base" label-placeholder="Last Name" v-model="current_user.last_name"></vs-input>
<!--    <vs-input class="w-full mb-base" label-placeholder="Name" v-model="name"></vs-input>-->
    <vs-input readonly class="w-full mb-base" label-placeholder="Email" v-model="current_user.email"></vs-input>
    <!-- <vs-input readonly class="w-full mb-base" label-placeholder="Phone" v-model="current_user.supplier.telephone"></vs-input> -->
    <!-- <vs-input readonly class="w-full mb-base" label-placeholder="Fax" v-model="current_user.supplier.fax"></vs-input> -->
    <!-- <vs-input readonly class="w-full mb-base" label-placeholder="Country" v-model="current_user.supplier.country"></vs-input> -->
    <!-- <vs-input readonly class="w-full mb-base" label-placeholder="Company Name" v-model="current_user.supplier.company_name"></vs-input> -->


    <vs-alert v-if="current_user.is_active === 0" icon-pack="feather" icon="icon-info" class="h-full my-4" color="warning">
      <span>Your account is not verified. <a href="#" class="hover:underline">Resend Confirmation</a></span>
    </vs-alert>
<!--    <vs-alert v-else icon-pack="feather" icon="icon-info" class="h-full my-4" color="success">-->
<!--      <span>Your account is verified.</span>-->
<!--    </vs-alert>-->
    <!-- Save & Reset Button -->
<!--    <div class="flex flex-wrap items-center justify-end">-->
<!--      <vs-button disabled class="ml-auto mt-2">Save Changes</vs-button>-->
<!--      <vs-button class="ml-4 mt-2" type="border" color="warning" disabled>Reset</vs-button>-->
<!--    </div>-->
  </vx-card>
</template>

<script>
import profile from '@/apis/profile.js'


export default {
  data () {
    return {
      current_user: {}
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    themeMode: {
      get ()    { return this.$store.state.theme },
      set (val) { this.$store.dispatch('updateTheme', val) }
    },
  },
  async mounted() {
    this.$vs.loading()
    const { data } =  (await profile.getCurrentUser()).data
    console.log(data);
    this.current_user = data
    this.$vs.loading.close()
  }
}
</script>
